import PropTypes from 'prop-types';


export default {
  tools: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.func.isRequired,
      link: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      testName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
